import styles from '../ChallengeDetail.module.scss';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';
import image161 from './images/16-1.jpg';
import image181 from './images/18-1.jpg';
import image182 from './images/18-2.jpg';

export const CompleteRegularCollectionDescription = () => {
    return (
        <div className={styles.description}>
            <p>
                <div>
                    Участвуйте 12 раз в розыгрышах за серые билеты, чтобы собрать обычную коллекцию
                </div>
                <div>
                    Посмотреть коллекцию можно в разделе <b>Активы</b>
                </div>
                <ChallengeDetailHelpImage image={image161} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Подраздел <b>«Коллекции»</b>
                </div>
                <ChallengeDetailHelpImage image={image181} helpText='Это картинка. Ищите вкладку в разделе «Активы».' />
            </p>
            <p>
                <div>
                    Далее ищите
                </div>
                <ChallengeDetailHelpImage image={image182} helpText='Это картинка. Ищите обычную коллекцуию в подразделе «Коллекции».' />
            </p>
        </div>
    );
}